import { useContext } from 'react';
import { SelectedClientContext } from '@providers';

export function useCurrentClient() {
  return useContext(SelectedClientContext);
}
